export const scrollToTop = () => {
  // Try multiple selectors to find the scrollable container
  const selectors = [
    '[class*="overflow-y-auto"]',
    '[class*="h-[calc(100vh-78px)]"]',
    '.overflow-y-auto',
    'main[data-slot="sidebar-inset"]',
  ]

  let scrollContainer: HTMLElement | null = null

  for (const selector of selectors) {
    scrollContainer = document.querySelector(selector) as HTMLElement
    if (scrollContainer) break
  }

  if (scrollContainer) {
    scrollContainer.scrollTo({ top: 0, behavior: 'smooth' })
  } else {
    // Fallback to window scroll
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
